import React from 'react';
import { browserVersion, isIE } from 'react-device-detect';

export default function UnsupportedBrowserAlert() {
  if (!isIE) return null;
  return (
    <div className="alert alert-danger position-absilute mb-0" role="alert">
      Internet Explorer {browserVersion} may have issues running PI Perform. Please use a modern browser such as{' '}
      <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/chrome/">
        Chrome
      </a>
      {' or '}
      <a target="_blank" rel="noopener noreferrer" href="https://www.microsoft.com/en-us/edge">
        Edge
      </a>
      .
    </div>
  );
}
